import '@mui/lab/themeAugmentation'

import { createTheme as createMuiTheme } from '@mui/material/styles'

import breakpoints from '@/theme/breakpoints'
import components from '@/theme/components'
import shadows from '@/theme/shadows'
import typography from '@/theme/typography'
import variants from '@/theme/variants'

const createTheme = (name: string) => {
  let themeConfig = variants.find(variant => variant.name === name)
  if (!themeConfig) {
    console.warn(new Error(`The theme ${name} is not valid`))
    themeConfig = variants[0]
  }
  return createMuiTheme(
    {
      spacing: 4,
      breakpoints,
      // @ts-expect-error Incompatible types
      components,
      typography,
      shadows,
      // @ts-expect-error Incomplete palette - missing tertiary
      palette: themeConfig.palette,
      sizes: {
        modal: {
          // @ts-expect-error Type mismatch - string vs number
          lg: '800px',
        },
        img: {
          xl: 500,
          lg: 300,
          md: 200,
          sm: 100,
          xs: 50,
        },
        skeleton: {
          xl: 50,
          lg: 40,
          md: 20,
          sm: 12,
          xs: 6,
          tiny: 1,
        },
        sidebar: {
          width: {
            variant: {
              lg: {
                xl: 450,
                lg: 400,
                md: 375,
                sm: 266,
              },
              sm: {
                xl: 350,
                lg: 300,
                md: 275,
                sm: 166,
              },
            },
          },
        },
      },
      view: {
        // @ts-expect-error Type mismatch - incomplete view structure
        col: '1200px',
        row: {
          // @ts-expect-error Type mismatch - string vs SxProps
          std: '100px',
        },
      },
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    },
  )
}

export default createTheme
